import React, { useState } from "react";
import { Link } from "react-router-dom";

const OUR_PRODUCTS_LINKS = [
  { label: "Housing Loan", slug: "housing-loan" },
  { label: "Personal Finance", slug: "personal-finance" },
  { label: "Gold Loan", slug: "gold-loan" },
  { label: "Loan Against Property", slug: "loan-against-property" },
  { label: "Corporate Finance", slug: "corporate-finance" },
  { label: "Loan Against Securities", slug: "loan-against-securities" },
  { label: "SME & Business Finance", slug: "sme-business-finance" },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [productsOpenMobile, setProductsOpenMobile] = useState(false);

  const handleToggle = () => setMenuOpen((open) => !open);
  const handleClose = () => {
    setMenuOpen(false);
    setProductsOpenMobile(false);
  };

  return (
    <header className="bg-[#192E6D] fixed top-0 left-0 right-0 z-50 shadow-none border-none" style={{ width: '1512px', maxWidth: '100%', height: '91px' }}>
      <div className="w-full h-full mx-auto px-6 lg:px-12 flex items-center">
        <div className="flex items-center justify-between w-full h-full">
          {/* Logo Section */}
          <div className="flex items-center flex-shrink-0">
            <Link 
              to="/" 
              onClick={handleClose} 
              className="flex flex-col items-center gap-1 no-underline outline-none border-none"
            >
              <img 
                src="/newlogo.png" 
                alt="Pawan Sut Logo" 
                className="h-48 w-48 md:h-56 md:w-56 lg:w-[384px] lg:h-[53px] object-contain block"
              />
              {/* <span className="text-white text-xs font-medium tracking-wide" style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}>
                Pawansut Holdings Limited
              </span> */}
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className={`xl:hidden flex flex-col justify-center items-center w-11 h-11 bg-transparent border-none cursor-pointer z-50 ml-4 transition-opacity ${menuOpen ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
            onClick={handleToggle}
            aria-label="Toggle navigation"
          >
            <span className="w-7 h-0.5 bg-white mb-1.5 rounded"></span>
            <span className="w-7 h-0.5 bg-white mb-1.5 rounded"></span>
            <span className="w-7 h-0.5 bg-white rounded"></span>
          </button>

          {/* Navigation Links - Desktop */}
          <nav className="hidden xl:flex items-center gap-8 flex-1 justify-end mr-10">
            <Link 
              className="text-white text-base font-normal no-underline hover:text-gray-300 transition-colors whitespace-nowrap"
              style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
              to="/" 
              onClick={handleClose}
            >
              Home
            </Link>
            <div
              className="relative"
              onMouseEnter={() => setProductsOpen(true)}
              onMouseLeave={() => setProductsOpen(false)}
            >
              <div className="text-white text-base font-normal hover:text-gray-300 transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer">
                <Link
                  to="/our-products"
                  onClick={handleClose}
                  className="no-underline"
                  style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
                >
                  Our Products
                </Link>
                <svg className={`w-4 h-4 transition-transform ${productsOpen ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              {productsOpen && (
                <div className="absolute top-full left-0 pt-2 min-w-[220px] z-[100]" style={{ marginTop: '4px' }}>
                  <div className="bg-[#192E6D] border border-white/20 rounded-lg shadow-2xl py-2">
                    {OUR_PRODUCTS_LINKS.map((item) => (
                      <Link
                        key={item.slug}
                        to={`/our-products#${item.slug}`}
                        onClick={handleClose}
                        className="block px-4 py-2.5 text-white text-sm no-underline hover:bg-white/10 transition-colors"
                        style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <Link 
              className="text-white text-base font-normal no-underline hover:text-gray-300 transition-colors whitespace-nowrap"
              style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
              to="/investor-relations" 
              onClick={handleClose}
            >
              Investor Relations
            </Link>
            <Link 
              className="text-white text-base font-normal no-underline hover:text-gray-300 transition-colors whitespace-nowrap"
              style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
              to="/leadership" 
              onClick={handleClose}
            >
              Leadership
            </Link>
            <Link 
              className="text-white text-base font-normal no-underline hover:text-gray-300 transition-colors whitespace-nowrap"
              style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
              to="/blogs" 
              onClick={handleClose}
            >
              Blogs
            </Link>
            <Link 
              className="text-white text-base font-normal no-underline hover:text-gray-300 transition-colors whitespace-nowrap"
              style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
              to="/partners" 
              onClick={handleClose}
            >
              Partners
            </Link>
            {/* <Link 
              className="text-white text-base font-normal no-underline hover:text-gray-300 transition-colors whitespace-nowrap" 
              to="/career" 
              onClick={handleClose}
            >
              Careers
            </Link> */}
            
            <Link 
              className="text-white text-base font-normal no-underline hover:text-gray-300 transition-colors whitespace-nowrap"
              style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
              to="/about" 
              onClick={handleClose}
            >
              About Us
            </Link>
          </nav>

          {/* Contact Us Button - Desktop */}
          <div className="hidden xl:flex items-center flex-shrink-0">
            <Link 
              to="/contact" 
              className="bg-white text-[#1a1a1a] px-7 py-2.5 rounded-md no-underline font-semibold text-base transition-all hover:bg-gray-100 whitespace-nowrap border-none outline-none cursor-pointer"
              style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
              onClick={handleClose}
            >
              Contact Us
            </Link>
          </div>
        </div>

        {/* Mobile Navigation Menu - Full Screen Overlay */}
        <div 
          className={`xl:hidden fixed inset-0 bg-[#192E6D] z-40 transition-all duration-300 ${
            menuOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'
          }`}
          onClick={handleClose}
        >
          <div 
            className="w-full h-full flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Mobile Menu Header */}
            <div className="flex items-center justify-between px-6 py-6 border-b border-white/10">
              <div className="flex flex-col items-center gap-1">
                <img 
                  src="/logo.png" 
                  alt="Pawan Sut Logo" 
                  className="h-16 w-16 object-contain"
                />
                <span className="text-white text-xs font-medium tracking-wide" style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}>
                  Pawansut holdings pvt. ltd.
                </span>
              </div>
              <button
                onClick={handleClose}
                className="w-10 h-10 flex items-center justify-center text-white hover:text-gray-300 transition-colors"
                aria-label="Close menu"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Mobile Menu List */}
            <div className="flex-1 px-6 py-8">
              <div className="flex flex-col space-y-4">
                <Link 
                  to="/" 
                  onClick={handleClose}
                  className="text-white text-lg font-medium py-4 px-4 rounded-lg hover:bg-white/10 transition-colors"
                  style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
                >
                  Home
                </Link>
                <div>
                  <button
                    type="button"
                    onClick={() => setProductsOpenMobile((o) => !o)}
                    className="w-full text-left text-white text-lg font-medium py-4 px-4 rounded-lg hover:bg-white/10 transition-colors flex items-center justify-between"
                    style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
                  >
                    Our Products
                    <svg className={`w-5 h-5 transition-transform ${productsOpenMobile ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {productsOpenMobile && (
                    <div className="pl-4 pb-2 flex flex-col space-y-1">
                      {OUR_PRODUCTS_LINKS.map((item) => (
                        <Link
                          key={item.slug}
                          to={`/our-products#${item.slug}`}
                          onClick={handleClose}
                          className="text-gray-300 text-base py-3 px-4 rounded-lg hover:bg-white/10 hover:text-white transition-colors"
                          style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
                        >
                          {item.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
                <Link 
                  to="/investor-relations" 
                  onClick={handleClose}
                  className="text-white text-lg font-medium py-4 px-4 rounded-lg hover:bg-white/10 transition-colors"
                  style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
                >
                  Investor Relations
                </Link>
                <Link 
                  to="/leadership" 
                  onClick={handleClose}
                  className="text-white text-lg font-medium py-4 px-4 rounded-lg hover:bg-white/10 transition-colors"
                  style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
                >
                  Leadership
                </Link>
                <Link 
                  to="/blogs" 
                  onClick={handleClose}
                  className="text-white text-lg font-medium py-4 px-4 rounded-lg hover:bg-white/10 transition-colors"
                  style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
                >
                  Blogs
                </Link>
                <Link 
                  to="/partners" 
                  onClick={handleClose}
                  className="text-white text-lg font-medium py-4 px-4 rounded-lg hover:bg-white/10 transition-colors"
                  style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
                >
                  Partners
                </Link>
                {/* <Link 
                  to="/career" 
                  onClick={handleClose}
                  className="text-white text-lg font-medium py-4 px-4 rounded-lg hover:bg-white/10 transition-colors"
                >
                  Careers
                </Link> */}
                <Link 
                  to="/about" 
                  onClick={handleClose}
                  className="text-white text-lg font-medium py-4 px-4 rounded-lg hover:bg-white/10 transition-colors"
                  style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
                >
                  About Us
                </Link>
              </div>
            </div>

            {/* Contact Us Button at Bottom */}
            <div className="px-6 pb-8">
              <Link 
                to="/contact" 
                onClick={handleClose}
                className="bg-white text-[#1a1a1a] w-full py-4 rounded-lg no-underline font-semibold text-base block text-center hover:bg-gray-100 transition-colors"
                style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
